import React, { useMemo, useState } from 'react'

import { useStore } from '../store'
import { ALERTS_ACTIONS } from '../store/alerts'
import useAvatar from '../hooks/api/useAvatar'
import { Box, Button, Typography, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'

import SettingsFooter from '../settings/shared/SettingsFooter'

const Avatar = () => {
  const { dispatch } = useStore()

  const {
    avatarUrl,
    setAvatarUrl,
    setSelectedFile,
    saveAvatar,

    reset,
    storeAvatarUrl,
  } = useAvatar()

  const onSuccess = () => {
    dispatch({
      type: ALERTS_ACTIONS.CREATE_ALERT,
      alert: {
        message: 'Avatar saved successfully',
        severity: 'success',
      },
    })
  }

  const onFailure = () => {
    dispatch({
      type: ALERTS_ACTIONS.CREATE_ALERT,
      alert: {
        message: 'Something went wrong',
        severity: 'error',
      },
    })
  }

  const buttons = useMemo(
    () => ({
      cancelButton: {
        onClick: () => {
          reset()
        },
      },
      saveButton: {
        onClick: () => {
          saveAvatar().then(onSuccess).catch(onFailure)
        },
        disabled: !storeAvatarUrl && !avatarUrl,
        label: avatarUrl || !storeAvatarUrl ? 'Save' : 'Remove Avatar',
      },
    }),
    [avatarUrl, storeAvatarUrl]
  )

  return (
    <Box>
      <ImageInput
        imageSrc={avatarUrl}
        setImageSrc={setAvatarUrl}
        setSelectedFile={setSelectedFile}
      />

      <SettingsFooter
        cancelButton={buttons.cancelButton}
        saveButton={buttons.saveButton}
      />
    </Box>
  )
}

export default Avatar

const ImageInput = ({ imageSrc, setImageSrc, setSelectedFile }) => {
  let inputRef

  const handleSelectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0])
      const reader = new FileReader()

      reader.onload = (e) => {
        setImageSrc(e.target.result)
      }

      reader.readAsDataURL(e.target.files[0])
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2,
          alignSelf: 'center',
        }}
      >
        {imageSrc && (
          <IconButton
            onClick={() => {
              setImageSrc(null)
              setSelectedFile(null)
              inputRef.value = null
            }}
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'white',
              boxShadow: '0px 1px 4px 1px rgb(0 0 0 / 20%)',
              ':hover': {
                backgroundColor: '#e7eaeb',
              },
            }}
          >
            <Close />
          </IconButton>
        )}
        {imageSrc ? (
          <img
            style={{
              borderRadius: '50%',
              width: '300px',
              height: '300px',
              objectFit: 'cover',
              backgroundColor: '#efefef',
              boxShadow: '0px 1px 4px 1px rgb(0 0 0 / 20%)',
            }}
            src={imageSrc}
            alt='uploaded-img'
          />
        ) : (
          <Box
            sx={{
              width: '300px',
              height: '300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button variant={'contained'} onClick={() => inputRef.click()}>
              Click to upload image
            </Button>
          </Box>
        )}
      </Box>

      <input
        hidden
        type='file'
        onChange={handleSelectFile}
        ref={(fileInputRef) => (inputRef = fileInputRef)}
      />
    </Box>
  )
}
